<template>
  <v-autocomplete
      prepend-icon="space_dashboard"
      :items="items"
      v-model="item"
      label="icons"
      :loading="loading"
      color="secondary"
      item-color="secondary"
      :rules="isRequired ? required : []"
      :multiple="multiple"
      :chips="chips"
      :solo="solo"
      :disabled="disabled"
      :readonly="readonly"
      :clearable="clearable"
  >
    <template v-slot:item="{item}">
        <v-list-item-avatar>
          <v-icon>{{item}}</v-icon>
        </v-list-item-avatar>
        <v-list-item-title>{{item}}</v-list-item-title>
    </template>

    <template v-slot:selection="data">
      <v-chip
          v-bind="data.attrs"
          :input-value="data.selected"
          @click="data.select" active small
      >
        <v-avatar left>
          <v-icon >{{data.item}}</v-icon>
        </v-avatar>
        {{ data.item }}
      </v-chip>
    </template>
  </v-autocomplete>

</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


import BaseProvider from "../../providers/BaseProvider"

export default {
  name: "GoogleMaterialIconCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {type: [String, Array]},
    multiple: {type: Boolean, default: false},
    solo: {type: Boolean, default: false},
    chips: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    isRequired: {type: Boolean, default: true},
    clearable: {type: Boolean, default: false},
  },
  data() {
    return {
      items: [],
      loading: false
    }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    fetch() {
      this.loading = true
      BaseProvider.fetchGoogleMaterialIcons().then(r => {
        this.items = r.data.fetchGoogleMaterialIcons
      }).catch(err => console.error(err))
          .finally(() => this.loading = false)
    }

  }
}
</script>

<style scoped>

</style>
